// eslint-disable-next-line no-unused-vars
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import SelectBox from "../SelectBox";

import {withTranslation} from "react-i18next";

const styles = () => ({
});

interface PassInProperty{
	classes: obejct,
	t: any,
	errorMessage: string,
	onChangeEvent: any
}

@withTranslation()
@withStyles(styles)
class TitleSelectBox extends React.Component<PassInProperty> {
	
	render(){
		const { 
			classes,
			t,
			errorMessage,
			onChangeEvent
		} = this.props;

		const opt_titles = [
			{
				label: {
					"en": "Title",
					"zh": "稱謂"
				},
				value: "",
				disable: true
			}, {
				label: {
					"en": "Mr",
					"zh": "先生"
				},
				value: "mr"
			}, {
				label: {
					"en": "Mrs",
					"zh": "女士"
				},
				value: "mrs"
			}, {
				label: {
					"en": "Miss",
					"zh": "小姐"
				},
				value: "miss"
			}
		];
	  
		return (
		<>
			<SelectBox
				options={opt_titles}
				defaultValue=""
				errorMessage={errorMessage}
				onChangeEvent={onChangeEvent}
				show_arrow={true}
				selectElementId="title"
			/>
		</>
		);
  	}
}

export default TitleSelectBox;